/* eslint-disable react-hooks/rules-of-hooks */
// eslint-disable react-hooks/exhaustive-deps

import React, { useMemo } from 'react';
import TableCell from '@material-ui/core/TableCell';
import { TMaterialTableColumns } from './index.types';
import MaterialTableRow from '@material-ui/core/TableRow';
import { useSetSortAsc, useSetSortHeader } from './reducer/actions';
import { useGetSortAsc, useGetSortHeader } from './reducer/selectors';

// TODO: fix the any types
const TableHeaderRow = <T,>({
    columns,
    setOrderBy,
    setOrderAsc,
    orderBy,
    orderAsc,
}: {
    columns: TMaterialTableColumns<T>;
    setOrderBy?: any;
    setOrderAsc?: any;
    orderBy?: any;
    orderAsc?: any;
}) => {
    let setSortHeader = useSetSortHeader();
    let setSortAsc = useSetSortAsc();
    let sortHeader = useGetSortHeader();
    let sortAsc = useGetSortAsc();
    if (orderBy) {
        setSortHeader = setOrderBy;
        setSortAsc = setOrderAsc;
        sortHeader = orderBy;
        sortAsc = orderAsc;
    }

    const retData = useMemo(
        () =>
            columns &&
            Array.isArray(columns) &&
            columns.map((value) => {
                const headerKey: string = (value?.key as string) || value.title;

                return (
                    <TableCell
                        onClick={() => {
                            if (!headerKey) return;

                            setSortHeader(headerKey);

                            if (sortHeader === headerKey) {
                                setSortAsc(!sortAsc);
                            }
                        }}
                        key={headerKey}
                    >
                        {value.title}
                        {sortHeader === headerKey
                            ? sortAsc
                                ? '(sort asc)'
                                : '(sort desc)'
                            : ''}
                    </TableCell>
                );
            }),
        [columns, setSortAsc, setSortHeader, sortAsc, sortHeader],
    );
    return <MaterialTableRow>{retData}</MaterialTableRow>;
};

export default TableHeaderRow;
